export const categories = [
  { slug: 'all', name: '全部作品', icon: 'ri-grid-line' },
  { slug: 'drama', name: '剧情片', icon: 'ri-film-line' },
  { slug: 'interview', name: '专访访谈', icon: 'ri-mic-line' },
  { slug: 'collection', name: '精选合集', icon: 'ri-star-line' },
  { slug: 'latest', name: '最新发布', icon: 'ri-fire-line' },
  { slug: 'behind-scenes', name: '幕后花絮', icon: 'ri-camera-line' },
];

export const articles = [
  {
    id: 'xl-001',
    title: '香菱主演《深夜的秘密》— 悬疑剧情巅峰之作',
    slug: 'shenye-de-mimi',
    category: 'drama',
    excerpt: '香菱在《深夜的秘密》中饰演一位心思缜密的女探员，在一桩离奇失踪案中展现出惊人的演技张力。本片以紧凑的叙事节奏和细腻的情感表达，成为香菱演艺生涯中的代表作之一。',
    content: `《深夜的秘密》是星空传媒2024年推出的重磅悬疑剧情片，由香菱领衔主演。影片讲述了一位女探员林薇（香菱饰）在调查一桩连环失踪案时，意外卷入了一场跨越十年的阴谋。

影片开篇即以一场紧张的追逐戏抓住观众眼球，香菱饰演的林薇在雨夜中追踪嫌疑人，湿漉漉的街道、闪烁的霓虹灯与她坚定的眼神形成了强烈的视觉对比。导演巧妙地运用光影变化，营造出扑朔迷离的悬疑氛围。

随着调查的深入，林薇逐渐发现案件背后隐藏着一个庞大的犯罪网络。香菱通过细腻的表演，将角色从最初的自信干练到后来陷入困境的无助，再到最终重拾信念的心理变化刻画得入木三分。特别是在审讯室与嫌疑人交锋的那场戏中，她的眼神从锐利到动摇，再到坚定，仅仅几秒钟就将角色的内心挣扎展现得淋漓尽致。

影片的高潮部分，林薇发现自己敬重的上司竟然是幕后黑手之一。这场对手戏堪称全片亮点，香菱与资深演员的飙戏令观众大呼过瘾。最终，真相大白，正义得到伸张，但林薇也在这一过程中付出了沉重代价，影片以一种克制而有力的方式收尾，留给观众无尽的回味。`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20moody%20cinematic%20scene%20of%20a%20female%20detective%20standing%20in%20a%20rainy%20alley%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20film%20noir%20atmosphere%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20mysterious%20and%20suspenseful%20mood%2C%20cinematic%20lighting%20with%20soft%20shadows&width=800&height=600&seq=xl-article-001&orientation=landscape',
    publishDate: '2024-11-15',
    duration: '118分钟',
    director: '陈海明',
    cast: ['香菱', '赵一凡', '林思远'],
    tags: ['悬疑', '剧情', '探案'],
    featured: true,
    rating: 9.4,
    views: 285000,
  },
  {
    id: 'xl-002',
    title: '香菱专访：从新人到实力派的蜕变之路',
    slug: 'cong-xinren-dao-shilipai',
    category: 'interview',
    excerpt: '星空传媒独家专访香菱，听她讲述从入行新人到实力派演员的心路历程。香菱坦言，每一部作品都是一次成长，观众的支持是她前进的最大动力。',
    content: `在星空传媒的独家专访中，香菱首次敞开心扉，分享了她从默默无闻到备受瞩目的成长故事。

"刚入行的时候，我什么都不懂，"香菱笑着回忆道，"第一次站在镜头前，腿都在发抖。但是导演跟我说，别怕，把真实的自己展现出来就好。"

香菱坦言，早期的几部作品对她来说是宝贵的学习机会。"每一部作品都是老师，我从中学会了如何控制情绪，如何理解角色，如何与搭档配合。"她的努力没有白费，随着《深夜的秘密》等一系列作品的热播，香菱的演技得到了观众和业内人士的广泛认可。

谈到最满意的角色，香菱毫不犹豫地选择了《深夜的秘密》中的林薇。"这个角色让我找到了一种表达方式，她坚强但不冰冷，柔软但不软弱。我希望通过这个角色，让观众看到女性的多面性。"

对于未来的规划，香菱表示希望尝试更多元化的角色。"我想演喜剧，想演古装，想挑战一切我没有尝试过的类型。演员不能被定义，我很期待未来的每一个角色。"`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20an%20Asian%20actress%20in%20a%20studio%20interview%20setting%2C%20soft%20warm%20lighting%2C%20professional%20photography%2C%20sitting%20on%20a%20comfortable%20chair%20with%20a%20genuine%20smile%2C%20behind%20the%20scenes%20documentary%20style%2C%20warm%20golden%20and%20rose%20tones&width=800&height=600&seq=xl-article-002&orientation=landscape',
    publishDate: '2024-10-28',
    duration: '45分钟',
    director: '星空传媒编辑部',
    cast: ['香菱'],
    tags: ['专访', '幕后', '个人故事'],
    featured: true,
    rating: 9.2,
    views: 156000,
  },
  {
    id: 'xl-003',
    title: '《都市恋语》— 香菱演绎现代爱情故事',
    slug: 'dushi-lianyu',
    category: 'drama',
    excerpt: '在星空传媒最新力作《都市恋语》中，香菱化身都市白领苏晴，与男主角展开一段温暖治愈的爱情故事。细腻的情感表达和真实的生活质感是本片最大亮点。',
    content: `《都市恋语》是星空传媒2024年秋季推出的都市情感剧，香菱在片中饰演广告公司创意总监苏晴，一位表面光鲜但内心孤独的都市女性。

影片以苏晴的日常生活为切入点，展现了她在职场打拼、人际交往和情感世界中的种种经历。香菱以极其自然的方式呈现了都市女性的多面性——工作中的干练果断、独处时的柔软脆弱、面对爱情时的犹豫与勇敢。

男主角陈墨（赵一凡饰）是一位独立音乐人，两人的偶然相遇开启了一段美好的缘分。影片最动人的一场戏发生在雨天的咖啡馆，苏晴和陈墨的对话简简单单，却蕴含着深深的情感，香菱的眼神和微表情让这场戏充满了诗意。

《都市恋语》不仅仅是一个爱情故事，它更是一面镜子，映射出当代都市年轻人对爱情、事业和生活的思考。影片结尾，苏晴最终选择勇敢追求自己的幸福，这个结局温暖而有力，给观众留下了无限想象空间。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20urban%20scene%20of%20a%20couple%20in%20a%20cozy%20cafe%20with%20rain%20outside%20the%20window%2C%20warm%20amber%20lighting%2C%20intimate%20atmosphere%2C%20modern%20city%20backdrop%20through%20glass%2C%20soft%20bokeh%20effect%2C%20cinematic%20romance%20photography&width=800&height=600&seq=xl-article-003&orientation=landscape',
    publishDate: '2024-09-20',
    duration: '105分钟',
    director: '王雨晴',
    cast: ['香菱', '赵一凡', '周晓雯'],
    tags: ['爱情', '都市', '治愈'],
    featured: true,
    rating: 9.1,
    views: 198000,
  },
  {
    id: 'xl-004',
    title: '星空传媒年度精选：香菱作品精华集锦',
    slug: 'niandu-jingxuan-ji jin',
    category: 'collection',
    excerpt: '星空传媒精心整理了香菱本年度所有精彩瞬间的精华合集。从悬疑剧情到甜蜜爱情，从专访花絮到幕后故事，一网打尽香菱的全部高光时刻。',
    content: `星空传媒年度精选合集收录了香菱2024年度所有精彩作品的高光片段。从年初的《深夜的秘密》到年末的《冬日暖阳》，香菱用一部部精品力作证明了自己的实力。

合集开篇以香菱各个角色的蒙太奇剪辑拉开帷幕，从英姿飒爽的女探员到温柔知性的都市白领，每个角色都令人印象深刻。配以香菱本人的旁白，讲述每个角色背后的故事和心得。

特别收录的幕后花絮是本次精选集的一大亮点。观众可以看到香菱在拍摄现场认真研读剧本、与导演沟通角色、和搭档排练对白的专业态度。这些珍贵的幕后画面展示了优秀作品背后的辛勤付出。

精选合集还包含了多段未曝光的独家采访片段，香菱分享了她在每个作品创作过程中的心路历程，以及她对演艺事业的深刻理解。本合集不仅是对香菱一年工作的回顾，更是送给粉丝的一份特别礼物。`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20montage%20style%20composition%20of%20cinematic%20film%20strips%20and%20behind%20the%20scenes%20moments%2C%20warm%20golden%20highlights%2C%20elegant%20film%20grain%20texture%2C%20vintage%20cinema%20aesthetic%2C%20soft%20dramatic%20lighting%2C%20rich%20amber%20and%20rose%20color%20palette&width=800&height=600&seq=xl-article-004&orientation=landscape',
    publishDate: '2024-12-10',
    duration: '92分钟',
    director: '星空传媒制作组',
    cast: ['香菱'],
    tags: ['精选合集', '年度回顾', '幕后花絮'],
    featured: false,
    rating: 9.5,
    views: 320000,
  },
  {
    id: 'xl-005',
    title: '《暗影追踪》— 香菱挑战动作戏极限',
    slug: 'anying-zhuizong',
    category: 'drama',
    excerpt: '香菱首次挑战高难度动作戏！在《暗影追踪》中，她饰演一位身手不凡的特工，亲自完成多场危险动作，展现了令人惊叹的敬业精神和身体控制力。',
    content: `《暗影追踪》是星空传媒2024年暑期推出的动作剧情大片，香菱在片中突破自我，首次挑战高难度动作戏份。

影片讲述了一位代号"暗影"的女特工（香菱饰）接到一项绝密任务，需要在48小时内阻止一场国际恐怖袭击。为了完成这个角色，香菱在拍摄前进行了长达三个月的特训，包括武术、格斗和武器使用训练。

影片中多场惊险刺激的动作戏均由香菱亲自完成，包括高空跳伞、摩托车追逐和近身格斗。导演在采访中透露，香菱在拍摄期间多次受伤，但她始终坚持不用替身，这种敬业精神令整个剧组为之动容。

除了精彩的动作场面，《暗影追踪》在剧情方面同样值得称赞。影片不仅有紧张刺激的任务执行，还有主角内心世界的深度挖掘。香菱通过细腻的表演，展现了一个表面冷酷无情但内心柔软温暖的特工形象，角色的复杂性让人过目不忘。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Action%20movie%20scene%20of%20a%20female%20agent%20in%20a%20dark%20urban%20setting%2C%20dramatic%20lighting%20with%20amber%20and%20crimson%20accents%2C%20intense%20atmosphere%2C%20cinematic%20action%20photography%2C%20rooftop%20chase%20scene%20at%20sunset%2C%20professional%20film%20grade%20color&width=800&height=600&seq=xl-article-005&orientation=landscape',
    publishDate: '2024-07-08',
    duration: '132分钟',
    director: '张浩宇',
    cast: ['香菱', '吴凯文', '陈思琪'],
    tags: ['动作', '特工', '悬疑'],
    featured: true,
    rating: 9.3,
    views: 356000,
  },
  {
    id: 'xl-006',
    title: '幕后揭秘：《暗影追踪》拍摄花絮全记录',
    slug: 'muhou-jiemi-anying',
    category: 'behind-scenes',
    excerpt: '带你走进《暗影追踪》拍摄现场！从武术特训到惊险动作场面，从剧本围读到杀青庆祝，全程记录香菱挑战自我的幕后故事。',
    content: `《暗影追踪》的幕后故事同样精彩纷呈。这支幕后花絮纪录了香菱从零开始学习武术到最终完成所有动作戏的全过程。

纪录片从香菱第一天走进武术训练馆开始。教练回忆道："她来的时候完全没有武术基础，但她的学习态度让我印象深刻。每天训练结束后，她还会自己加练一个小时。"

在为期三个月的特训中，香菱掌握了基础格斗技巧、武器操作和高空特技。训练中最难的部分是克服恐高，但为了角色，她在第三周就成功完成了首次高空跳跃训练。

拍摄现场的花絮更是精彩。有一场摩托车追逐戏，因为角度问题反复拍摄了十七次，香菱每次都全力以赴。杀青那天，整个剧组为她的敬业精神鼓掌致敬，香菱激动得热泪盈眶。

这支花絮不仅是对一部电影幕后工作的记录，更是对香菱作为演员的敬业精神和专业态度的最好证明。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20cameras%20and%20lighting%20equipment%2C%20action%20movie%20production%2C%20crew%20members%20working%2C%20warm%20studio%20lighting%2C%20professional%20film%20production%20atmosphere%2C%20documentary%20style%20photography%20with%20rich%20amber%20tones&width=800&height=600&seq=xl-article-006&orientation=landscape',
    publishDate: '2024-08-15',
    duration: '38分钟',
    director: '星空传媒幕后组',
    cast: ['香菱', '张浩宇', '武术指导团队'],
    tags: ['幕后花絮', '动作训练', '拍摄记录'],
    featured: false,
    rating: 9.0,
    views: 128000,
  },
  {
    id: 'xl-007',
    title: '香菱最新力作《冬日暖阳》温情上线',
    slug: 'dongri-nuanyang',
    category: 'drama',
    excerpt: '星空传媒年末温情巨献《冬日暖阳》，香菱饰演一位返乡创业的年轻女性，用温暖治愈的故事为这个冬天增添一抹亮色。',
    content: `《冬日暖阳》是星空传媒2024年末重磅推出的温情剧情片，香菱在片中饰演从大城市回到家乡创业的年轻设计师林暖。

故事发生在一个被冰雪覆盖的北方小镇。林暖辞去了大城市的高薪工作，回到家乡开了一家手工艺品工作室。这个看似冲动的决定背后，隐藏着她对生活的重新思考和对故土的深深眷恋。

香菱将林暖这个角色诠释得极为动人。从最初面对乡亲质疑时的坚定，到创业过程中遇到挫折时的迷茫，再到找到方向后的豁然开朗，每一个情绪转折都自然流畅。特别值得一提的是片中林暖与奶奶的对手戏，两代人对生活不同理解的碰撞，既有温情又有深度，令人动容。

影片的视觉风格同样值得称赞，导演用大量的雪景和暖色调灯光营造出一种独特的冬日美学。香菱在雪中奔跑、在工作室专注制作手工艺品的画面，成为本片最具标志性的经典镜头。`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20warm%20winter%20scene%20in%20a%20snowy%20small%20town%2C%20cozy%20handcraft%20workshop%20with%20warm%20golden%20light%20spilling%20through%20windows%2C%20snow%20falling%20gently%20outside%2C%20peaceful%20and%20heartwarming%20atmosphere%2C%20cinematic%20photography%20with%20soft%20amber%20and%20cream%20tones&width=800&height=600&seq=xl-article-007&orientation=landscape',
    publishDate: '2024-12-20',
    duration: '110分钟',
    director: '李若涵',
    cast: ['香菱', '刘奶奶（特邀）', '赵一凡'],
    tags: ['温情', '返乡', '治愈'],
    featured: true,
    rating: 9.6,
    views: 285000,
  },
  {
    id: 'xl-008',
    title: '对话香菱：关于表演，关于生活，关于热爱',
    slug: 'duihua-xiangling-biaoyan',
    category: 'interview',
    excerpt: '在本次深度访谈中，香菱罕见地分享了她的表演哲学和生活态度。从如何理解角色到如何平衡工作与生活，每一句话都透露出她对演艺事业的深沉热爱。',
    content: `星空传媒特别策划的深度对话栏目，邀请香菱进行了一场关于表演、生活和热爱的走心访谈。

问：你是如何准备一个角色的？

香菱："我会先反复阅读剧本，不是一两遍，而是至少十遍。在这个过程中，我会在脑海中构建角色的完整人生——她的童年是什么样的，她经历过什么，她的梦想是什么。只有完全理解了一个人，才能真实地扮演她。"

问：你觉得演员最重要的品质是什么？

香菱："真诚。观众的眼睛是雪亮的，任何虚假的表演都会被识破。所以我在表演时，会让自己完全相信我就是那个人物。这种'相信'不是技巧，而是一种从内心涌出的真实感受。"

问：工作之余，你喜欢做什么？

香菱："我喜欢一个人去旅行，去那些没有多少人认识我的地方。在陌生的环境里，我可以完全放松下来，观察不同的人和事。这些经历后来都变成了我表演的养分。"

这场访谈持续了两个多小时，香菱毫无保留地分享了她对表演艺术的思考和追求，让观众看到了一个更加立体、更加真实的香菱。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Intimate%20portrait%20of%20an%20actress%20in%20a%20warm%20living%20room%20setting%2C%20soft%20natural%20light%20from%20large%20windows%2C%20thoughtful%20expression%2C%20cozy%20atmosphere%20with%20books%20and%20plants%2C%20professional%20portrait%20photography%2C%20rich%20golden%20hour%20lighting&width=800&height=600&seq=xl-article-008&orientation=landscape',
    publishDate: '2024-11-05',
    duration: '52分钟',
    director: '星空传媒访谈组',
    cast: ['香菱'],
    tags: ['深度访谈', '表演哲学', '个人生活'],
    featured: false,
    rating: 9.3,
    views: 167000,
  },
  {
    id: 'xl-009',
    title: '《夏日恋曲》— 香菱清新演绎青春爱情',
    slug: 'xiari-lianqu',
    category: 'drama',
    excerpt: '阳光、沙滩、青春的脸庞——香菱在《夏日恋曲》中回到青涩的学生时代，用最纯粹的方式讲述一段关于初恋的美好故事。',
    content: `《夏日恋曲》是星空传媒2024年夏季推出的青春爱情片，香菱在片中饰演大学生林小夏，将一个关于初恋的故事演绎得纯粹而美好。

故事设定在海滨城市，林小夏在暑假实习期间遇到了来自不同城市的男孩顾阳。从最初的互不理解到渐渐产生好感，再到分别时的依依不舍，整部影片如同一首清新的夏日小诗。

香菱在《夏日恋曲》中的表演与她以往的作品形成了有趣的对比。在这里，她卸下了所有成熟的包装，回归到最本真的少女状态。那些微妙的情绪变化——偷偷看对方时的羞涩、第一次牵手时的心跳加速、分别时强忍的泪水——都被她演绎得极其真实。

影片的画面美学同样令人心旷神怡，碧蓝的海水、金色的沙滩、傍晚的霞光，每一个场景都像一幅精心构图的油画，将青春的美好定格在银幕之上。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Youthful%20summer%20romance%20scene%20on%20a%20beautiful%20beach%20at%20golden%20hour%2C%20young%20couple%20walking%20along%20the%20shore%2C%20warm%20sunset%20colors%2C%20carefree%20and%20nostalgic%20atmosphere%2C%20cinematic%20photography%20with%20soft%20amber%20and%20coral%20tones&width=800&height=600&seq=xl-article-009&orientation=landscape',
    publishDate: '2024-06-15',
    duration: '98分钟',
    director: '刘思洋',
    cast: ['香菱', '李明宇', '周小雨'],
    tags: ['青春', '爱情', '夏日'],
    featured: false,
    rating: 8.9,
    views: 215000,
  },
  {
    id: 'xl-010',
    title: '《香菱作品年度总览》— 2024完整回顾特辑',
    slug: 'xiangling-2024-huigu',
    category: 'collection',
    excerpt: '全面回顾香菱在2024年度的全部作品与精彩表现。从年初到年末，每一部作品、每一个角色、每一次突破，都在这里完整呈现。',
    content: `2024年对香菱来说是丰收的一年。这一年，她出演了八部作品，涵盖了悬疑、动作、爱情、温情等多种类型，展现了令人惊叹的表演广度。

年度回顾从一月开始，香菱以《深夜的秘密》开启了2024年的精彩序幕。这部悬疑剧情片不仅在观众中获得极高评价，也为香菱赢得了"年度最佳女演员"提名。

暑期档的《暗影追踪》是香菱演艺生涯的一个重要转折点，她首次挑战动作戏并大获成功，证明了演技派也能驾驭商业大片。随后的《夏日恋曲》又展现了她驾驭青春题材的能力。

秋季的《都市恋语》回归细腻情感表达，冬季的《冬日暖阳》则以温情收官。加上多场深度访谈和幕后花絮的发布，2024年无疑是香菱全面绽放的一年。

本特辑不仅是对作品的回顾，更是一份送给粉丝的年度礼物。通过时间线的梳理，观众可以清晰看到香菱在这一年中的成长轨迹和艺术追求。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20collage%20of%20film%20posters%20and%20cinematic%20moments%2C%20year%20in%20review%20theme%2C%20golden%20film%20awards%20aesthetic%2C%20warm%20spotlight%20effect%2C%20luxurious%20amber%20and%20deep%20red%20tones%2C%20cinematic%20montage%20with%20soft%20glow&width=800&height=600&seq=xl-article-010&orientation=landscape',
    publishDate: '2024-12-28',
    duration: '75分钟',
    director: '星空传媒编辑部',
    cast: ['香菱'],
    tags: ['年度回顾', '合集', '作品总览'],
    featured: false,
    rating: 9.7,
    views: 402000,
  },
];

export const featuredArticles = articles.filter(a => a.featured);

export const getArticleBySlug = (slug: string) => articles.find(a => a.slug === slug);

export const getArticlesByCategory = (categorySlug: string) => {
  if (categorySlug === 'all') return articles;
  return articles.filter(a => a.category === categorySlug);
};

export const getRelatedArticles = (currentSlug: string, limit: number = 3) => {
  return articles.filter(a => a.slug !== currentSlug).slice(0, limit);
};